export const mockedProjectDetails = {
    "a484781c-1a88-4d3a-b388-c1374f1148b1": {
        name: "nnillni/backstage:packages/backend/package.json",
        id: "a484781c-1a88-4d3a-b388-c1374f1148b1",
        created: "2023-05-23T08:27:18.202Z",
        origin: "github-enterprise",
        type: "yarn",
        readOnly: false,
        testFrequency: "daily",
        totalDependencies: 1030,
        issueCountsBySeverity: {
            low: 1,
            high: 4,
            medium: 3,
            critical: 0,
        },
        remoteRepoUrl: "https://github.com/nnillni/backstage",
        imageId: "",
        imageTag: "0.0.0",
        imagePlatform: "",
        hostname: null,
        lastTestedDate: "2023-11-10T22:23:33.784Z",
        browseUrl: "https://app.snyk.io/org/nnillni/project/a484781c-1a88-4d3a-b388-c1374f1148b1",
        owner: null,
        importingUser: {
            id: "82688b24-2a82-317e-ba8e-02a1221aa097",
            name: "Foo bar",
            username: "foobar@company.org",
            email: "foobar@company.org",
        },
        isMonitored: true,
        tags: [],
        attributes: {
            criticality: [],
            lifecycle: [],
            environment: [],
        },
        remediation: {
            pin: {},
            patch: {},
            upgrade: {},
        },
        branch: "qa",
        targetReference: "qa",
    },
    "29ee792c-6d39-45a3-a3db-c38fa52d44c3": {
        name: "nnillni/backstage:packages/app/package.json",
        id: "29ee792c-6d39-45a3-a3db-c38fa52d44c3",
        created: "2023-05-23T08:27:18.021Z",
        origin: "github-enterprise",
        type: "yarn",
        readOnly: false,
        testFrequency: "daily",
        totalDependencies: 2048,
        issueCountsBySeverity: {
            low: 1,
            high: 4,
            medium: 6,
            critical: 1,
        },
        remoteRepoUrl: "https://github.com/nnillni/backstage",
        imageTag: "0.0.0",
        hostname: null,
        lastTestedDate: "2023-11-11T00:52:06.725Z",
        browseUrl: "https://app.snyk.io/org/nnillni/project/29ee792c-6d39-45a3-a3db-c38fa52d44c3",
        owner: null,
        importingUser: {
            id: "82688b24-2a82-317e-ba8e-02a1221aa097",
            name: "Foo bar",
            username: "foobar@company.org",
            email: "foobar@company.org",
        },
        isMonitored: true,
        tags: [],
        attributes: {
            criticality: [],
            lifecycle: [],
            environment: [],
        },
        remediation: {
            pin: {},
            patch: {},
            upgrade: {},
        },
        branch: "qa",
        targetReference: "qa",
    },
    "895278ab-0b64-42c0-a69d-96ef4705f164": {
        name: "nnillni/backstage:package.json",
        id: "895278ab-0b64-42c0-a69d-96ef4705f164",
        created: "2023-05-23T08:27:17.642Z",
        origin: "github-enterprise",
        type: "yarn",
        readOnly: false,
        testFrequency: "daily",
        totalDependencies: 0,
        issueCountsBySeverity: {
            low: 0,
            high: 0,
            medium: 0,
            critical: 0,
        },
        remoteRepoUrl: "https://github.com/nnillni/backstage",
        imageTag: "1.0.0",
        hostname: null,
        lastTestedDate: "2023-11-11T03:00:12.547Z",
        browseUrl: "https://app.snyk.io/org/nnillni/project/895278ab-0b64-42c0-a69d-96ef4705f164",
        owner: null,
        importingUser: {
            id: "82688b24-2a82-317e-ba8e-02a1221aa097",
            name: "Foo bar",
            username: "foobar@company.org",
            email: "foobar@company.org",
        },
        isMonitored: true,
        tags: [],
        attributes: {
            criticality: [],
            lifecycle: [],
            environment: [],
        },
        remediation: {
            pin: {},
            patch: {},
            upgrade: {},
        },
        branch: "qa",
        targetReference: "qa",
    },
    "0bc4da77-ee44-4ce9-b33e-39edaa2ae1e9": {
        name: "nnillni/backstage:Dockerfile",
        id: "0bc4da77-ee44-4ce9-b33e-39edaa2ae1e9",
        created: "2023-05-23T08:27:13.975Z",
        origin: "github-enterprise",
        type: "dockerfile",
        readOnly: false,
        testFrequency: "daily",
        totalDependencies: 0,
        issueCountsBySeverity: {
            low: 0,
            high: 0,
            medium: 0,
            critical: 0,
        },
        remoteRepoUrl: "https://github.com/nnillni/backstage",
        imageTag: "nnillni-18.13-alpine",
        imageBaseImage: "12345678910.dkr.ecr.eu-wasp-1.amazonaws.com/dev/node:18.13-alpine",
        hostname: null,
        lastTestedDate: "2023-11-11T04:55:34.631Z",
        browseUrl: "https://app.snyk.io/org/nnillni/project/0bc4da77-ee44-4ce9-b33e-39edaa2ae1e9",
        owner: null,
        importingUser: {
            id: "82688b24-2a82-317e-ba8e-02a1221aa097",
            name: "Foo bar",
            username: "foobar@company.org",
            email: "foobar@company.org",
        },
        isMonitored: true,
        tags: [],
        attributes: {
            criticality: [],
            lifecycle: [],
            environment: [],
        },
        remediation: {
            pin: {},
            patch: {},
            upgrade: {},
        },
        branch: "qa",
        targetReference: "qa",
    },
};
//# sourceMappingURL=mockedProjectDetails.js.map